<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        Организација
      </h1>

      <p class="subtitle">Организација у дирекцији</p>
      <nav class="level" v-show="loggedIn">
        <div class="level-left">
          <p class="level-item">
            <router-link
              :to="{
                name: 'ResursForma',
                params: { id: null, tip: 'organizacija' }
              }"
            >
              <b-button
                size="is-mediom"
                icon-pack="fas"
                icon-left="user"
                type="is-warning"
              >
                Нова организација
              </b-button>
            </router-link>
          </p>
        </div>
      </nav>
      <Resurs
        v-for="resurs in resursi"
        :key="resurs.id"
        :resurs="resurs"
        :izmenaDozvoljena="loggedIn"
        :datumVidljiv="false"
        :tekstVidljiv="false"
        :slikaVidljiva="false"
        :dokumentVidljiv="true"
        :linkDetaljiVidljiv="false"
      ></Resurs>

      <br />
      <!-- bulma je mnogo prostija -->
      <nav class="">
        <router-link
          :to="{ name: 'Organizacija', query: { page: page - 1 } }"
          class="button is-pulled-left"
          v-show="hasPrevPage"
          >&lt;&lt; Претходно</router-link
        >
        <router-link
          :to="{ name: 'Organizacija', query: { page: page + 1 } }"
          class="button is-pulled-right"
          v-show="hasNextPage"
          >Даље &gt;&gt;</router-link
        >
      </nav>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Resurs from '../components/Resurs'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Resurs,
    Footer
  },
  data() {
    return {
      // filtri: {
      //   datum_od: '2020-01-01',
      //   datum_do: '2020-12-01'
      // }
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.$store
      .dispatch('resursi/dajResurse', {
        type: 'organizacija',
        perPage: this.$store.state.perPage,
        page: to.query.page,
        filters: {}
      })
      .then(() => {
        next()
      })
  },
  computed: {
    page() {
      return parseInt(this.$route.query.page) || 1
    },
    // hasNextPage() {
    //   return this.resursi.resursaUkupno > this.page * this.perPage
    // },
    hasPrevPage() {
      return this.page !== 1
    },
    hasNextPage() {
      return this.resursaUkupno > this.page * this.$store.state.perPage
    },
    ...mapState('auth', ['loggedIn', 'userData']),
    ...mapState('resursi', ['resursi', 'resursaUkupno'])
  }
}
</script>

<style></style>
